import { render } from "./PostModal.vue?vue&type=template&id=38cddca4&scoped=true"
import script from "./PostModal.vue?vue&type=script&lang=js"
export * from "./PostModal.vue?vue&type=script&lang=js"

import "./PostModal.vue?vue&type=style&index=0&id=38cddca4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-38cddca4"

export default script